import { create } from 'zustand'
import { persist } from 'zustand/middleware'

const usePersistStore = create(
  persist(
    (set, get) => ({
      setPersistStore: (obj: any) => set(obj),
    }),
    { name: 'ikg' }
  )
)

export default usePersistStore
